/**
 * @generated SignedSource<<eb5cb207204fa560d648832dcc88ca91>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appointmentDrawerHeader_patient$data = {
  readonly id: string;
  readonly patientId: string;
  readonly " $fragmentType": "appointmentDrawerHeader_patient";
};
export type appointmentDrawerHeader_patient$key = {
  readonly " $data"?: appointmentDrawerHeader_patient$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawerHeader_patient">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentDrawerHeader_patient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    }
  ],
  "type": "Patient",
  "abstractKey": "__isPatient"
};

(node as any).hash = "bd7aa39ae8c64d63c9d080d3fc56e428";

export default node;
